<!--
 * @Author: wang peng
 * @Description: 电站列表
-->
<template>
  <scroll-layout class="fleet-match-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <ykc-table
      ref="YkcTable"
      operateFixedType="right"
      :data="tableData"
      :title="tableTitle"
      :columns="tableColumns"
      :operateButtons="tableOperateButtons.filter(item => item.enabled())">
      <template #headerButtons>
        <div class="table-header-button">
          <ykc-button v-rbac="'asset:station:third:export'" type="plain" @click="doExportFile">
            导出
          </ykc-button>
        </div>
      </template>

      <ykc-pagination
        align="right"
        slot="pagination"
        ref="YkcPagination"
        :total="pageInfo.total"
        :page-size.sync="pageInfo.size"
        :current-page.sync="pageInfo.current"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"></ykc-pagination>
    </ykc-table>
  </scroll-layout>
</template>
<script>
  import { offlineExport, code } from '@/utils';

  import { stationPage, treeUtils } from '@/service/apis';

  export default {
    name: 'thirdConnectionStationList',
    components: {
      // ImportData,
    },
    inject: ['reload'],
    data() {
      return {
        addressData: [], // 省市区
        searchParams: {
          name: '',
          stationOperatorId: '',
          ids: [],
          provinceId: '',
          cityId: '',
          districtId: '',
        },
        tableTitle: '电站列表',
        tableData: [],
        tableOperateButtons: [
          {
            id: '2',
            text: '详情',
            enabled: () => code('asset:station:third:detail'),
            handleClick: (btn, { row }) => {
              this.$router.push({
                path: '/plantAssets/powerStationManagement/thirdConnectionStation/Detail',
                query: { stationId: row.stationId },
              });
            },
          },
        ], // 列表操作
        tableColumns: [
          { label: 'ID', prop: 'stationId', minWidth: '200px', id: 1 },
          {
            label: '电站名称',
            prop: 'name',
            id: 2,
            minWidth: '250px',
          },
          {
            label: '电站地址',
            prop: 'detailAddress',
            id: 3,

            minWidth: '250px',
          },
          {
            label: '站点联系电话',
            prop: 'telephone',
            id: 8,
            minWidth: '100px',
          },
          {
            label: '电站状态',
            prop: 'startStatusDesc',
            id: 7,
            minWidth: '100px',
          },
          {
            label: '品牌',
            prop: 'brand',
            id: 4,
            minWidth: '250px',
          },
        ],
        pageInfo: {
          current: 1,
          size: 10,
        },
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'name',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcCascader',
            key: 'ids',
            label: '省市区',
            placeholder: '请选择省市区',
            configSet: {
              label: 'name',
              value: 'id',
              children: 'subNodes',
            },
            options: this.addressData,
            filterable: true,
            clearable: true,
            checkStrictly: true,
          },
        ];
      },
    },
    created() {
      const { id } = this.$route.query;
      this.searchParams.stationOperatorId = id;
      this.requestGetDistrict();
      this.requestList();
    },
    methods: {
      /**
       * 导出
       */
      doExportFile() {
        offlineExport(
          {
            downloadType: 'third_station_export',
            jsonNode: {
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        Object.assign(this.searchParams, searchData);
        if (searchData.ids) {
          [this.searchParams.provinceId, this.searchParams.cityId, this.searchParams.districtId] =
            searchData.ids || [];
        }
        this.pageInfo.current = 1;
        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      /**
       *
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       *
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },

      /**
       * 获取区域数据
       */
      requestGetDistrict() {
        treeUtils
          .getDistrict({})
          .then(res => {
            this.addressData = res.districts;
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 请求列表数据
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        stationPage
          .thirdFindByPage(reqParams)
          .then(res => {
            this.tableData = res.records;
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-table {
    .el-table .el-table__row {
      .cell .userStatus {
        padding-left: 8px;
        position: relative;
      }

      .cell .userStatus::after {
        display: block;
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 100%;
        background: #d0021b;
        position: absolute;
        top: 5.5px;
        left: 0;
      }

      .cell .status-blue::after {
        background: #4d8cfd;
      }

      .cell .status-green::after {
        background: #02c498;
      }

      .cell .status-black::after {
        background: #9b9b9b;
      }
    }

    .sealBtn {
      color: #4d8cfd;
      cursor: pointer;
    }

    .row-item {
      padding: 0px 4px;
      font-size: 10px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      border-radius: 7px;
      display: inline-block;
    }

    .row-item-txt {
      padding: 0 4px;
      min-width: 30px;
      text-align: center;
      display: inline-block;
    }

    .row-green {
      background: linear-gradient(180deg, #07c160 0%, #02e495 100%);
    }

    .row-blue {
      background: linear-gradient(180deg, #1779fe 0%, #72aeff 100%);
    }
  }

  ::v-deep.ykc-checkbox .icon-check {
    top: 8px;
  }

  ::v-deep.customForm .el-form-item,
  ::v-deep.customForm .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
</style>
